import { render, staticRenderFns } from "./UndoRedoControl.vue?vue&type=template&id=0e178ceb&scoped=true&"
import script from "./UndoRedoControl.vue?vue&type=script&lang=js&"
export * from "./UndoRedoControl.vue?vue&type=script&lang=js&"
import style0 from "./undoRedoControl.scss?vue&type=style&index=0&id=0e178ceb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e178ceb",
  null
  
)

export default component.exports